"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useOffsetLocations = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _react = require("react");
var _markerConstants = require("../../../lib/markerConstants");
const useOffsetLocations = (locations, showMultipleMarkersForSameLocation) => {
  const normalizeCoordinates = (0, _react.useCallback)(coordinates => {
    if ((0, _isArray.default)(coordinates)) {
      return {
        lon: coordinates[0],
        lat: coordinates[1]
      };
    }
    if (coordinates && typeof coordinates === 'object' && 'lat' in coordinates && 'lon' in coordinates) {
      return {
        lon: coordinates.lon,
        lat: coordinates.lat
      };
    }
    return null;
  }, []);

  // Converts polar coordinates (r, θ) to cartesian (x, y) using:
  // x = r * cos(θ) <- horizontal displacement
  // y = r * sin(θ) <- vertical displacement
  //
  // More context on this approach:
  // Imagine drawing a circle around the original point. This calculates
  // where to place a new point on that circle's edge at a specific angle
  // angle is already calculated based on the number of locations at the same point
  const applyOffset = (0, _react.useCallback)((coords, angle, distance) => ({
    lon: coords.lon + distance * Math.cos(angle),
    lat: coords.lat + distance * Math.sin(angle)
  }), []);
  const reconstructCoordinates = (0, _react.useCallback)((coords, originalCoords) => {
    if ((0, _isArray.default)(originalCoords)) {
      return [coords.lon, coords.lat];
    }
    return coords;
  }, []);
  return (0, _react.useMemo)(() => {
    if (!showMultipleMarkersForSameLocation) {
      return locations;
    }
    const coordinateGroups = new _map.default();
    (0, _forEach.default)(locations).call(locations, location => {
      if (location.coordinates) {
        const normalizedCoords = normalizeCoordinates(location.coordinates);
        if (normalizedCoords) {
          const coordKey = `${normalizedCoords.lon},${normalizedCoords.lat}`;
          if (!coordinateGroups.has(coordKey)) {
            coordinateGroups.set(coordKey, []);
          }
          coordinateGroups.get(coordKey)?.push(location);
        }
      }
    });
    const offsetLocations = [];
    (0, _forEach.default)(coordinateGroups).call(coordinateGroups, locationsAtCoord => {
      if (locationsAtCoord.length === 1) {
        offsetLocations.push(locationsAtCoord[0]);
      } else {
        (0, _forEach.default)(locationsAtCoord).call(locationsAtCoord, (location, index) => {
          // This angle is calculated based on the number of the locations.
          // For example in simple case of 2 locations, the angles will be 0 and π (180 degrees)
          // in case of 4 it will be 90 degrees apart (0, π/2, π, 3π/2)
          // converting this to radians for calculations
          const angle = index * 2 * Math.PI / locationsAtCoord.length;
          const normalizedCoords = normalizeCoordinates(location.coordinates);
          if (normalizedCoords) {
            const offsetCoords = applyOffset(normalizedCoords, angle, _markerConstants.OFFSET_DISTANCE);
            const offsetCoordinates = reconstructCoordinates(offsetCoords, location.coordinates);
            offsetLocations.push({
              ...location,
              coordinates: offsetCoordinates,
              originalCoordinates: location.coordinates
            });
          }
        });
      }
    });
    return offsetLocations;
  }, [locations, applyOffset, normalizeCoordinates, reconstructCoordinates, showMultipleMarkersForSameLocation]);
};
exports.useOffsetLocations = useOffsetLocations;